import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import Todo from 'src/store/models/Todo';
import User from 'src/store/models/User';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: {
    todoId: {
      type: Number,
      required: true
    },
    allowEditTask: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      logEntries: [],
      loading: false
    };
  },
  computed: {
    todo: function todo() {
      return Todo.query().with(['todo_list.project', 'tags', 'integration']).find(this.todoId);
    }
  },
  methods: {
    isNewEstimate: function isNewEstimate(logEntry) {
      return !logEntry.old_estimate || logEntry.old_estimate === '0.00';
    },
    loadEstimateLog: function loadEstimateLog() {
      var _this = this;

      this.loading = true;
      Todo.api().getEstimateLog(this.todoId).then(function (result) {
        _this.logEntries = result.response.data;
      }).finally(function () {
        _this.loading = false;
      });
    },
    getUserAvatar: function getUserAvatar(userId) {
      return User.query().with('avatar').find(userId).avatar.avatar_url;
    },
    openTodoDialog: function openTodoDialog() {
      this.openDialog('TodoDialog', {
        todoId: this.todo.todo_id
      });
    }
  },
  mounted: function mounted() {
    this.loadEstimateLog();
  }
};